/* Moved verbatim out of sections/gift-builder.liquid (2026-10-05) to keep the section under Shopify's 256 KB cap. Loaded synchronously at the same position. */
(function () {
  var EP = "https://same-skies-byo-inventory.same-skies.workers.dev/availability";
  function apply(avail) {
    document.querySelectorAll(".gb-product-card[data-variant]").forEach(function (card) {
      // Prints are made on demand and their Shopify inventory is not tracked.
      if (card.dataset.id === "art_print") return;
      // a card is dead only if its CURRENT variant AND all its swatch variants are dead
      var ids = [card.dataset.variant];
      card.querySelectorAll(".gb-swatch[data-variant-id]").forEach(function (s) { ids.push(s.dataset.variantId); });
      var anyAlive = ids.some(function (id) { return avail[id] !== false; });
      card.classList.toggle("gb-oos", !anyAlive);
      card.querySelectorAll(".gb-swatch[data-variant-id]").forEach(function (s) {
        s.classList.toggle("gb-oos", avail[s.dataset.variantId] === false);
      });
      if (avail[card.dataset.variant] === false && !card.classList.contains("selected")) {
        var alive = card.querySelector(".gb-swatch[data-variant-id]:not(.gb-oos)");
        if (alive && typeof window.gbSelectSwatch === "function") window.gbSelectSwatch(alive);
      }
    });
  }
  function init() {
    var ids = {};
    document.querySelectorAll(".gb-product-card[data-variant], .gb-swatch[data-variant-id]").forEach(function (el) {
      var v = el.dataset.variant || el.dataset.variantId;
      if (v && /^\d+$/.test(v)) ids[v] = 1;
    });
    var list = Object.keys(ids);
    if (!list.length) return;
    fetch(EP + "?ids=" + list.join(","))
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () { /* fail open */ });
    // capture-phase guards: a dead card/swatch can't be toggled or picked
    document.addEventListener("click", function (e) {
      var dead = e.target.closest && e.target.closest(".gb-product-card.gb-oos, .gb-swatch.gb-oos");
      if (dead) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
